<template>

<div>
	<b-dropdown class="category_dropdown m-2" right :text="title" size="sm">
		<b-dropdown-item 
			v-for="(item, key) in options" :key="key"
		>
			<router-link :to="item.value">
				<i :class="item.icon"></i> <span v-text="item.text"></span>
			</router-link>
		</b-dropdown-item>
	</b-dropdown>
</div>
</template>

<script>
export default {
	name: 'CategoryDropdown',
		props: {
			title: String,
		},
		data() {
			return {
			}
		},
		computed: {
			options(){
				var options = [{ value: '/', text: 'All Categories', icon: 'fas fa-list' }];
				for (const obj of Object.values(this.$store.getters.categoriesGet)) {
					var label = obj.title + "("+ obj.num +")";
					var link = "/categories/" + obj.slug;
					options.push({ value: link, text: label, icon: obj.icon });
				}
				return options;
			}
		},
		created(){
		},
		methods:{
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
